import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class CalendarInviteBindService {

  public bindEmitter: EventEmitter<string> = new EventEmitter();

}
